import { useEffect, useRef, useState } from "react";
import { pdfjs } from "react-pdf";
import { useStores } from "../../store";
import { useNavigate } from "react-router-dom";
import { interviewsList } from "../../helpers/constantVariables";
import axios from "axios";
import { apiPostPut } from "../../api/api_methods";
import { createInterview } from "../../api/recruiterAssessmentsApi";
import { uploadFileToAzure } from "../../services/azure";
import { Observer } from "mobx-react";
import { AiOutlineCopy, AiOutlineLeft } from "react-icons/ai";
import { AdditionalSettings, CustomQuestionForm } from "../dashboard/dashboard";
import { MdFileUpload, MdOutlineAdd } from "react-icons/md";
import { FaCircleNotch } from "react-icons/fa";
import { getUserRoleFromLocalStorage } from "../../services/reusable";
import { getDomainForWhiteLabeling } from "../../services/white_label";
import HelpCenter from "../reusble_components/helpCenter";

export function CompanyInterviewForm() {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
  const [selectedFileName, setSelectedFileName] = useState(null);
  const [selectedFileByUser, setSelectFileByUser] = useState(null);
  const { InterviewStore, PopupStore, RecuiterStore, UserStore, CommonStore } =
    useStores();
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const studentDetails = JSON.parse(localStorage.getItem("user_google"));
  const [name, setName] = useState(studentDetails?.name ?? "");
  const [technology, setTechnology] = useState("");
  const [noOfQuestions, setnoOfQuestions] = useState("5");
  const [level, setLevel] = useState("low");
  const [showMeetingForm, setShowMeetingForm] = useState(true);
  const [role, setRole] = useState("");
  const [company, setCompany] = useState("");
  const [title, settitle] = useState("");
  const [invitationLink, setInvitationLink] = useState(null);
  const [waiting, setWaiting] = useState(false);
  const [wantToUploadResume, setWantToUploadResume] = useState(true); // this is used to highlight the options
  const [attempts, setAttempts] = useState(-1);
  const StudentOriginalName = JSON.parse(localStorage.getItem("user"));

  const fetchData = async (pdfFile) => {
    try {
      const response = await axios.get(pdfFile, {
        responseType: "arraybuffer",
      });

      const pdfData = response.data; // Directly use response.data as array buffer

      const pdf = await pdfjs.getDocument({ data: pdfData }).promise;
      let fullText = "";

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const content = await page.getTextContent();
        const pageText = content.items.map((item) => item.str).join("\n");
        fullText += pageText + "\n";
      }

      // setExtractedText(fullText);
      console.log(fullText);
      InterviewStore.setResumeText(fullText);
    } catch (error) {
      console.error("Error fetching or parsing PDF file", error);
    }
  };
  useEffect(() => {
    const customSettings = JSON.parse(localStorage.getItem("customSettings"));
    try {
      setAttempts(customSettings[3].value);
    } catch (error) {}
  }, []);

  // const [disableForm, setDisableForm] = useState(showMeetingForm);

  const handlechangeName = (e) => {
    setName(e.target.value);
  };
  const handlechangeTechnology = (e) => {
    setTechnology(e.target.value);
  };
  const handlechangeRole = (e) => {
    setRole(e.target.value);
    console.log(role);
  };
  const handlechangeCompany = (e) => {
    setCompany(e.target.value);
    console.log(company);
  };

  // const handlechangelevel = (e) => {
  //   if (e.target.value === "1") setLevel("low");
  //   else if (e.target.value === "2") setLevel("medium");
  //   else if (e.target.value === "3") setLevel("high");
  //   else setLevel("low");
  // };

  const OpenInterviewScreenBySendingParams = async (e) => {
    e.preventDefault();
    localStorage.removeItem("career");

    let resumeLink = null;

    const userDetails = UserStore.userDetails;
    let response = null;
    try {
      const customSettings = JSON.parse(localStorage.getItem("customSettings"));
      const id = JSON.parse(localStorage.getItem("interviewId"));
      console.log(userDetails);
      console.log(id);
      const body = {
        userId: userDetails._id,
        attempts: customSettings[3].value,
        invitationFrom: id,
      };
      setAttempts(customSettings[3].value);
      response = await apiPostPut(
        body,
        "/interview/validate-custom-settings",
        "POST",
      );
      console.log("validation", response);
    } catch (error) {}

    if (
      userDetails?.role?.role != "company" &&
      userDetails?.role?.role != "consultancy"
    ) {
      // check resume uploaded or not for resume based interview for user or students
      const idOfResumeBasedInterviews = [2, 4, 8];
      if (
        idOfResumeBasedInterviews.includes(
          InterviewStore.interviewSettings?.id ??
            InterviewStore.interviewSettings?.interviewId,
        )
      ) {
        if (InterviewStore.resumeFile === null) {
          return alert("Please upload your resume");
        }

        const resumeFileName = Date.now() + InterviewStore.resumeFile?.name;

        const resumeUploadResponse = await uploadFileToAzure(
          resumeFileName,
          InterviewStore.resumeFile,
          { action: "interview" },
        );
        if (resumeUploadResponse?.success) {
          resumeLink = resumeUploadResponse?.url;
        }
      }
    }

    let interviewDetails = {
      name: name,
      technology: technology,
      levelOfInterview: level === "" ? "low" : level,
      noOfQuestions: noOfQuestions,
      role: role,
      company: company,
      customQuestions: InterviewStore.customQuestions,
      // resume: InterviewStore.resumeFile,
      resume: InterviewStore.resumeText,
    };
    if (InterviewStore.companyInterview) {
      console.log("companyInterview", InterviewStore.additionalSettings);
      interviewDetails.customSettings = [
        {
          name: "video",
          value: InterviewStore.additionalSettings.camera,
        },
        {
          name: "resume",
          value: InterviewStore.additionalSettings.resume,
        },
        {
          name: "screen",
          value: InterviewStore.additionalSettings.screen,
        },
        {
          name: "attempts",
          value: InterviewStore.additionalSettings.attempts,
        },
      ];
      console.log("hello", interviewDetails);
    }
    if (resumeLink !== null) {
      interviewDetails["resumeLink"] = resumeLink;
    }

    console.log(userDetails);
    // return;

    if (
      userDetails?.role?.role === "company" ||
      userDetails?.role?.role === "consultancy"
    ) {
      // InterviewStore.changeInterviewIdByIdForResume(
      //   InterviewStore.interviewSettings?.id
      // );
      interviewDetails["interviewer"] = userDetails?._id;
      interviewDetails["interviewType"] = "real";
      InterviewStore.updateInterviewDetails(interviewDetails);

      let body = {
        ...InterviewStore.interviewSettings,
        isInvitation: true,
      };

      if (RecuiterStore.clientId) {
        body.client = RecuiterStore.clientId;
      }

      delete body.id;

      console.log(body);

      setWaiting(true);
      const apiResponse = await createInterview(body);
      setWaiting(false);
      console.log(apiResponse);
      if (
        (apiResponse.status === 200 || apiResponse.status === 201) &&
        apiResponse.body?.success
      ) {
        alert("Interview-invitation created successfully");

        const data = apiResponse.body?.data;
        console.log(data?.interviewLink);
        setInvitationLink(
          data?.interviewLink ??
            `https://${getDomainForWhiteLabeling()}/share?page=interview_invitation&id=${data?._id}`,
        );
      } else {
        alert("Something went wrong");
      }

      return;
    }

    // localStorage.setItem("interviewDetails", JSON.stringify(interviewDetails));
    InterviewStore.updateInterviewDetails(interviewDetails);
    console.log(InterviewStore.interviewDetails);
    // navigate(
    //   `/interview?name=${name}&technology=${technology}&level=${level}&question=${noOfQuestions}&id=${InterviewStore.interviewSettings?.id}`
    // );
    // Construct the new URL
    const newURL = `/interview?name=${name}&technology=${technology}&level=${level}&question=${noOfQuestions}&id=${InterviewStore.interviewSettings?.id}`;

    // Set the new URL and trigger a reload
    console.log(response);
    console.log(InterviewStore.companyInterview, "companyInterview");

    if (!InterviewStore.validation) {
      window.location.href = newURL;
      return;
    }
    if (response.status === 200) {
      window.location.href = newURL;
    } else {
      alert(response.body.message);
    }
  };

  const handleModal = () => {
    InterviewStore.setInterviewModal(3);
    // console.log(InterviewStore.interviewModal);
    alert("  ");
    // console.log(JSON.parse(localStorage.getItem("interviewSettings")));
    let interviewSettings = JSON.parse(
      localStorage.getItem("interviewSettings"),
    );
    interviewSettings.model = 3;
    // console.log(interviewSettings);
    localStorage.setItem(
      "interviewSettings",
      JSON.stringify(interviewSettings),
    );
  };
  const handleFileChange = (event) => {
    const selectedFile = event.currentTarget.files[0];

    if (selectedFile) {
      InterviewStore.setResumeFile(selectedFile);
      const fileURL = URL.createObjectURL(selectedFile);
      fetchData(fileURL);
      // const { name } = selectedFile;
      // setSelectedFileName(name); // Update the state with the filename
      // setSelectFileByUser(selectedFile);
    }
  };

  const enableFieldByRole = () => {
    const role = getUserRoleFromLocalStorage();

    console.log(role);

    if (role === null) return;

    InterviewStore.enableInterviewFormById(
      InterviewStore.interviewSettings?.id ??
        InterviewStore?.interviewSettings?.interviewId,
      role,
    );

    switch (role) {
      case "company":
      case "consultancy":
        console.log(InterviewStore.interviewSettings?.id);
        InterviewStore.setShowCustomQuestions();
        // InterviewStore.changeInterviewIdByIdForResume(
        //   InterviewStore.interviewSettings?.id
        // ); // this will enable resume based interview by default

        break;

      default:
        break;
    }
  };

  const autoFillSomeFields = () => {
    setnoOfQuestions(
      InterviewStore.interviewSettings?.noOfQuestions ?? noOfQuestions,
    );
    setLevel(InterviewStore.interviewSettings?.levelOfInterview ?? level);
    setTechnology(InterviewStore.interviewSettings?.technology ?? technology);
  };

  const consoleMobxFields = () => {
    console.log(InterviewStore.showTechnology);
    console.log(InterviewStore.showName);
    console.log(InterviewStore.showInterviewLevel);
    console.log(InterviewStore.showNoOfQuestions);
  };

  useEffect(() => {
    console.log("form opened 💥", InterviewStore.interviewSettings.interviewId);

    enableFieldByRole();
    autoFillSomeFields();
    consoleMobxFields(); // remove this later

    return () => {
      InterviewStore.resetInterviewFields();
    };
  }, []);

  useEffect(() => {
    console.log("Selected file name:", selectedFileName);
    console.log(selectedFileByUser);
  }, [selectedFileName]); // This effect runs when selectedFileName changes

  const attachResume = (value) => {
    setWantToUploadResume(value);
    InterviewStore.setShowResume(value);
    InterviewStore.changeInterviewIdByIdForResume(
      InterviewStore.interviewSettings?.id,
    );
  };
  const handleCopyClick = () => {
    // Create a textarea element to temporarily hold the text
    const textarea = document.createElement("textarea");
    textarea.value = invitationLink;

    // Append the textarea to the document
    document.body.appendChild(textarea);

    // Select the text in the textarea and copy it to the clipboard
    textarea.select();
    document.execCommand("copy");

    // Remove the textarea from the document
    document.body.removeChild(textarea);
    window.alert("link copied");
  };

  const getInterviewDescription = () => {
    const interviewId = InterviewStore.interviewSettings?.interviewId;
    const interview = interviewsList.find(
      (interview) => interview?.id === interviewId,
    );
    if (interview) {
      settitle(interview?.title);
      return interview?.description;
    }
  };

  // const handleCompanyInterview = () => {
  //   if(fromCompany){
  //     navigate("/company/interview");
  //   }
  //   else{
  //     PopupStore.setCreateInterview(true)
  //   }
  //   }

  const backFunction = () => {
    InterviewStore.setAdditionalSettings("camera", false);
    InterviewStore.setAdditionalSettings("resume", false);
    InterviewStore.setAdditionalSettings("screen", false);
    InterviewStore.setAdditionalSettings("attempts", 2);
    setShowMeetingForm(false);
    //   PopupStore.setTopicBasedInterview(false);
    if (CommonStore.createNewBack) {
      navigate("/company/services");
      CommonStore.setCreateNewBack(false);
    } else {
      navigate("/company/interview");
    }
  };

  return (
    <Observer>
      {() => (
        <>
          <HelpCenter />
          <div className="flex flex-col md:flex-row lg:flex-row justify-around md:mt-0 lg:mt-0 mt-[15%] ">
            <div className="pl-8 pt-10 md:p-10 flex flex-col w-[90%] md:w-[50%] relative">
              <button
                className="flex items-center text-primary  gap-2 text-xl cursor-pointer absolute md:left-[5%] lg:left-[5%] left-[3%] top-[8%] md:top-[6%] lg:top-[7%]"
                onClick={backFunction}
              >
                <AiOutlineLeft /> Back
              </button>
              <h1 className="text-2xl md:text-4xl font-extrabold mt-5 md:mt-16 lg:mt-28 leading-[50px]">
                Create a <br />
                <span className="text-primary mt-0">
                  {InterviewStore.interviewSettings?.title ?? title}{" "}
                </span>
                {/* Interview Session */}
              </h1>
              <p className="text-base md:text-xl mt-5 md:mt-8">
                {getInterviewDescription()}{" "}
              </p>
            </div>
            <form
              className="flex flex-col justify-center items-center relative md:w-[50%] lg:w-[40%] my-4 lg:ml-0 md:ml-0 ml-5 py-3 h-[100%] mt-14 md:mt-20 lg:mt-28"
              onSubmit={OpenInterviewScreenBySendingParams}
            >
              {/* <h1 className="text-center text-primary text-[30px]">Interview Creation</h1> */}
              {/* <div className="mr-2 ml-auto ">
              <div className="w-6 h-6 text-lg text-bg3 m-auto cursor-pointer  rounded-full  bg-primary" >
                <p className="flex justify-center items-center  m-auto"><span className="m-auto">x</span></p>
              </div>
            </div> */}

              {InterviewStore.showName && (
                <div className="mb-2 w-full md:w-[70%] lg:w-[65%]">
                  <label
                    htmlFor="name"
                    className="block mb-1 md:mt-2 ml-2 font-medium md:text-base lg:text-lg"
                  >
                    Candidate Name*
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    defaultValue={
                      StudentOriginalName?.name ||
                      UserStore?.userDetails?.name ||
                      studentDetails?.name
                    }
                    onChange={handlechangeName}
                    className="px-5 py-5 text-primary rounded-xl border border-primary w-[95%] h-[40px] md:h-[45px] md:text-lg lg:text-xl focus:outline-none "
                  />
                </div>
              )}
              {InterviewStore.showTechnology && (
                <div
                  className={`mb-2 w-full md:w-[70%] lg:w-[65%] ${
                    InterviewStore.maskingFields.includes("technology")
                      ? "pointer-events-none"
                      : ""
                  }`}
                >
                  <label
                    htmlFor="technology"
                    className="block mb-1 md:mt-2 ml-2 font-medium md:text-base lg:text-lg"
                  >
                    Topic of Interview (Technology)*
                  </label>
                  <input
                    type="text"
                    id="technology"
                    required
                    name="technology"
                    value={technology}
                    onChange={handlechangeTechnology}
                    className=" px-5 py-5 text-primary rounded-xl border border-primary w-[95%] h-[40px] md:h-[45px] md:text-lg lg:text-xl focus:outline-none "
                  />
                </div>
              )}

              {InterviewStore.showNoOfQuestions && (
                <div
                  className={`mb-2 w-full md:w-[70%] lg:w-[65%] ${
                    InterviewStore.maskingFields.includes("noOfQuestions")
                      ? "pointer-events-none"
                      : ""
                  }`}
                >
                  <label
                    htmlFor="technology"
                    className="block mb-1 md:mt-2 ml-2 font-medium md:text-base lg:text-lg"
                  >
                    Select No of questions
                  </label>
                  <select
                    className=" px-5 py-3 rounded-xl w-[95%] h-[45px] md:h-[45px] md:text-lg lg:text-xl text-primary border text-center border-primary  focus:outline-none "
                    value={noOfQuestions}
                    onChange={(e) => setnoOfQuestions(e.target.value)}
                  >
                    <option defaultChecked={true}>5 Questions</option>
                    <option value={10}>10 Questions</option>
                  </select>
                </div>
              )}

              {InterviewStore.showCompany || InterviewStore.showRole ? (
                <>
                  {InterviewStore.showCompany && (
                    <div className="mb-2 w-full md:w-[70%] lg:w-[65%]">
                      <label
                        htmlFor="name"
                        className="block mb-1 md:mt-2 ml-2 font-medium md:text-base lg:text-lg"
                      >
                        Company
                      </label>
                      <input
                        onChange={handlechangeCompany}
                        required
                        type="text"
                        id="name"
                        name="name"
                        className="px-5 py-5 text-primary rounded-xl border border-primary w-[95%] h-[40px] md:h-[45px] md:text-lg lg:text-xl focus:outline-none"
                      />
                    </div>
                  )}
                  {InterviewStore.showRole && (
                    <div className="mb-2 w-full md:w-[70%] lg:w-[65%]">
                      <label
                        htmlFor="name"
                        className="block mb-1 md:mt-2 ml-2 font-medium md:text-base lg:text-lg"
                      >
                        Role
                      </label>
                      <input
                        onChange={handlechangeRole}
                        required
                        type="text"
                        id="name"
                        name="name"
                        className="px-5 py-5 text-primary rounded-xl border border-primary w-[95%] h-[40px] md:h-[45px] md:text-lg lg:text-xl focus:outline-none"
                      />
                    </div>
                  )}
                </>
              ) : null}

              {/* {InterviewStore.interviewSettings.id === 4 ? (
                    <div>
                      <div>
                        <div className="mb-4">
                          <label
                            htmlFor="name"
                            className="block  font-medium"
                          >
                            Company
                          </label>
                          <input
                            required
                            type="text"
                            id="name"
                            name="name"
                            onChange={handlechangeCompany}
                            className="px-2 text-primary border-b-2 border-border2  h-[30px] w-[300px] md:w-[300px] lg:w-[500px] focus:outline-none "
                          />
                        </div>
                      </div>
                      <div>
                        <div className="mb-4">
                          <label
                            htmlFor="name"
                            className="block  font-medium"
                          >
                            Role
                          </label>
                          <input
                            required
                            type="text"
                            id="name"
                            name="name"
                            onChange={handlechangeRole}
                            className="px-2 text-primary border-b-2 border-border2  h-[30px] w-[300px] md:w-[300px] lg:w-[500px] focus:outline-none "
                          />
                        </div>
                      </div>
                      <div className="flex flex-col items-center justify-center space-x-4">
                        <input
                          id="fileInput"
                          type="file"
                          className="hidden"
                          onChange={handleFileChange}
                        />
                        <label
                          htmlFor="fileInput"
                          className="px-4 py-2 w-full flex justify-center items-center gap-3 text-center bg-primary text-white rounded-md cursor-pointer hover:bg-[#e67f34] transition duration-300 ease-in-out"
                        >
                          <MdFileUpload /> Upload Resume
                        </label>
                        <div className="flex flex-row w-full justify-between">
                          <p className="text-blue-500">
                            {InterviewStore.resumeFile?.name}
                          </p>
                          <p className="text-blue-500 cursor-pointer">Change</p>
                        </div>
                      </div>{" "}
                    </div>
                  ) : null} */}
              {InterviewStore.showInterviewLevel && (
                <div
                  className={`mb-2 w-full md:w-[70%] lg:w-[65%] ${
                    InterviewStore.maskingFields.includes("interviewLevel")
                      ? "pointer-events-none"
                      : ""
                  }`}
                >
                  <label
                    htmlFor="level"
                    className="block mt-2 mb-1 ml-2 font-medium md:text-base lg:text-lg"
                    onDoubleClick={handleModal}
                  >
                    Select Level
                  </label>
                  <select
                    className=" px-5 py-3 rounded-xl w-[95%] h-[45px] md:h-[45px] md:text-lg lg:text-xl text-primary border text-center border-primary  focus:outline-none "
                    value={level}
                    onChange={(e) => setLevel(e.target.value)}
                  >
                    <option defaultChecked={true} value="low">
                      Low
                    </option>
                    <option value="medium">Medium</option>
                    <option value="high">High</option>
                  </select>

                  {/* <div className="flex flex-row w-full">
                            <button
                              type="button"
                              className={`${level === "low"
                                ? "bg-primary text-bg3"
                                : "bg-primary2 text-text_color3"
                                } w-[80px] px-5 py-2 rounded-[10.49px] text-center `}
                              onClick={() => setLevel("low")}
                            >
                              Low
                            </button>
                            <button
                              type="button"
                              className={`${level === "medium"
                                ? "bg-primary text-bg3"
                                : "bg-primary2 text-text_color3"
                                } w-[80px] px-2 py-2 rounded-[10.49px] ml-5 text-center`}
                              onClick={() => setLevel("medium")}
                            >
                              Medium
                            </button>
  
                            <button
                              type="button"
                              onClick={() => setLevel("high")}
                              className={`${level === "high"
                                ? "bg-primary text-bg3"
                                : "bg-primary2 text-text_color3"
                                } w-[80px] px-5 py-2 rounded-[10.49px] ml-5 text-center`}
                            >
                              High
                            </button>
                          </div> */}
                </div>
              )}
              {InterviewStore.companyInterview && (
                <div
                  className={`mb-2 w-full md:w-[70%] lg:w-[65%] ${
                    InterviewStore.maskingFields.includes("technology")
                      ? "pointer-events-none"
                      : ""
                  }`}
                >
                  <label
                    htmlFor="technology"
                    className="block mb-1 md:mt-2 ml-2 font-medium md:text-base lg:text-lg"
                  >
                    No of Attempts
                  </label>
                  <input
                    type="number"
                    id="technology"
                    required
                    name="technology"
                    value={InterviewStore.additionalSettings.attempts}
                    onChange={(e) => {
                      InterviewStore.setAdditionalSettings(
                        "attempts",
                        Number(e.target.value),
                      );
                    }}
                    className=" px-5 py-5 text-primary rounded-xl border border-primary w-[95%] h-[40px] md:h-[45px] md:text-lg lg:text-xl focus:outline-none "
                  />
                </div>
              )}
              {InterviewStore.companyInterview && (
                <div className=" mb-2 w-full md:w-[70%] lg:w-[65%]">
                  <AdditionalSettings />
                </div>
              )}
              {InterviewStore.showCustomQuestions && (
                <div className=" mb-2 w-full md:w-[70%] lg:w-[65%]">
                  <CustomQuestionForm />
                </div>
              )}

              {invitationLink !== null && (
                <div className="flex w-full md:w-[70%] lg:w-[65%]">
                  <textarea
                    className="w-full h-[100px]"
                    value={invitationLink}
                  />
                  <span
                    class="flex text-gray-800 cursor-pointer w-5 h-5 hover:text-gray-400 duration-200"
                    onClick={handleCopyClick}
                  >
                    {" "}
                    <AiOutlineCopy className="text-xl active:text-primary" />
                  </span>
                </div>
              )}

              {InterviewStore.askHaveResume &&
                InterviewStore.ResumeCompanyInterview && (
                  <div
                    className={`mb-1 md:mt-2 w-[100%] pr-5 flex flex-row items-center justify-between md:w-[70%] lg:w-[65%] ${
                      InterviewStore.maskingFields.includes("askHaveResume")
                        ? ""
                        : ""
                    }`}
                  >
                    <label
                      htmlFor="level"
                      className="block text-center items-center md:ml-2 font-medium md:text-base lg:text-lg"
                      // onDoubleClick={handleModal}
                    >
                      Do you have a Resume?
                    </label>

                    <div className="flex  gap-2 md:gap-5 items-center mr-2">
                      <label
                        className={`radio-label flex text-center items-center  justify-center gap-1 md:gap-2 ${
                          wantToUploadResume === true ? "selected" : ""
                        }`}
                      >
                        <p className="md:text-base">Yes</p>
                        <input
                          type="radio"
                          className="cursor-pointer"
                          value="No"
                          checked={wantToUploadResume === true}
                          onChange={() => attachResume(true)}
                        />
                      </label>
                      <label
                        className={`radio-label flex text-center items-center  justify-center gap-1 md:gap-2 ${
                          wantToUploadResume === false ? "selected" : ""
                        }`}
                      >
                        <p className="md:text-base">No</p>
                        <input
                          type="radio"
                          className="cursor-pointer"
                          value="Yes"
                          checked={wantToUploadResume === false}
                          onClick={() => attachResume(false)}
                        />
                      </label>
                    </div>
                  </div>
                )}

              {InterviewStore.showResume ? (
                <div className="my-2  w-full md:w-[70%] lg:w-[65%]">
                  <div className="flex flex-col">
                    <input
                      id="fileInput"
                      type="file"
                      className="hidden"
                      onChange={handleFileChange}
                      accept=".pdf"
                    />
                    <label
                      htmlFor="fileInput"
                      className={`px-4 py-1 w-fit min-w-[95%]  text-center flex items-center border lg:gap border-primary rounded-xl cursor-pointer  transition duration-300 ease-in-out ${
                        InterviewStore.showResume
                          ? "gap-1 justify-center"
                          : "gap-2 "
                      }`}
                    >
                      <p className="font-semibold text-sm">
                        {InterviewStore.resumeFile?.name}
                      </p>{" "}
                      <div
                        className={`flex  items-center  h-[35px] md:text-lg lg:text-xl ${
                          InterviewStore.showResume ? "gap-1" : "gap-2"
                        }`}
                      >
                        <MdFileUpload className="text-primary text-2xl" />{" "}
                        Upload Resume
                      </div>
                    </label>
                    {/* {selectedFileName && (
                          <p className="text-blue-500">{selectedFileName}</p>
                        )} */}
                  </div>
                </div>
              ) : null}

              {/* <div className="opacity-600 mb-2 text-[0.8rem] w-[100%] flex flex-row font-semibold items-center text-text_color3">
                  <AiOutlineInfoCircle className="mx-2 text-[1rem]" />
                  <p>100 credits will be deducted for each interview</p>
                </div> */}

              {/* {attempts !== -1 && (
                <div className="mb-2 w-full md:w-[70%] lg:w-[65%]">
                  <p className=" text-lg">
                    You can attempt{" "}
                    <span className="text-primary text-lg font-bold">
                      {attempts} times
                    </span>{" "}
                    only
                  </p>
                </div>
              )} */}

              <button
                type="submit"
                className={`text-bg3 ${
                  invitationLink ? "hidden" : "block"
                } flex flex-row justify-center ml-[-4%] items-center text-center my-5 text-[18px] font-bold  px-3 rounded-2xl h-[60px] bg-primary w-[95%]  md:w-[67%] lg:w-[61%] gap-2`}
              >
                {waiting ? (
                  <FaCircleNotch className="text-primary2 animate-spin text-3xl" />
                ) : (
                  <span className="text-[30px] text-white text-center w-8 h-8 flex items-center justify-center rounded-full border-2 border-white ">
                    <MdOutlineAdd />
                  </span>
                )}
                <p className="ml-2">
                  {waiting ? "Please wait..." : "New Interview"}
                </p>
              </button>
            </form>
          </div>
        </>
      )}
    </Observer>
  );
}
